import { useEffect, useRef } from 'react';
import { useGTM } from './useGTM';

export const useTimeTracking = (pageName: string) => {
  const { pushEvent } = useGTM();
  const startTime = useRef<number>(Date.now());

  useEffect(() => {
    return () => {
      const timeSpent = Math.round((Date.now() - startTime.current) / 1000);
      pushEvent('time_on_page', {
        page: pageName,
        seconds: timeSpent,
      });
    };
  }, [pageName, pushEvent]);
};
